import { useState } from 'react';
import useApi from 'services/mavapi/useApi';
import {

  GroupedPaymentPlans,
  PaymentService,
  PlanAmountUpdate,
} from 'services/openapi';

const usePaymentApi = () => {
  const [loading, setLoading] = useState(false);
  const [, setError] = useState<unknown | null>();
  const { error: apiError, handleRequest } = useApi();
  const [paymentPlansList, setPaymentPlansList] = useState<
    Array<GroupedPaymentPlans>
  >([]);
  //API Services
  const {
    paymentGetGroupedPaymentPlans, paymentUpdatePlanAmount
  } = PaymentService;

  const getPaymentPlansList = () => {
    setLoading(true);
    handleRequest(paymentGetGroupedPaymentPlans())
      .then(data => {
        console.log(data, 'datadata')
        if (data) setPaymentPlansList(data);
        setLoading(false);
      })

      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  const updatePaymentPlan = (requestBody?: PlanAmountUpdate, onSuccess?: () => void) => {
    setLoading(true);
    handleRequest(paymentUpdatePlanAmount(requestBody))
      .then(async data => {
        if (data) {
          if (onSuccess) {
            await onSuccess();
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  return {
    loading,
    setLoading,
    getPaymentPlansList,
    paymentPlansList,
    updatePaymentPlan
  };
};

export default usePaymentApi;
